<template>
    <div class="accordion-item text-dark">
        <!-- Node with children -->
        <div v-if="node.children" class="accordion-button collapsed py-2" data-bs-toggle="collapse"
            data-bs-parent="leftNav" :data-bs-target="'#' + getID(node.name)" aria-expanded="false"
            :aria-controls="getID(node.name)">
            <div :class="labelPadding" @click="goTo(node)">{{ node.name }}</div>
        </div>
        <div :id="getID(node.name)" class="accordion-collapse collapse" :aria-labelledby="getID(node.name)">
            <LeftNavElement v-for="    child in node.children    " :key="child.name" :node="child"
                :level="level + 2" />
        </div>

        <!-- Node without children -->
        <div :class="{ active: $route.path == node.path }" v-if="!node.children" class="accordion-body py-2"
            @click="goTo(node)">
            <div :class="labelPadding">{{ node.name }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LeftNavElement",
    props: {
        node: Object,
        level: Number
    },
    data() {
        return {
            open: false,
            labelPadding: 'ps-' + this.level // this will only work with two levels, might need to think about left padding
        }
    },
    methods: {
        toggle() {
            this.open = !this.open
        },
        goTo(node) {
            if (node.path === undefined) {
                return
            }
            window.open(node.path, '_self')

            // Close the mobile nav menu
            let mobileNavEl = document.getElementById('navbarSupportedContent')
            mobileNavEl.classList.remove('show')
        },
        getID(name) {
            if (name) {
                let regex = /\W\.\s/g
                // Convert to lowercase and return the result.
                name = name.replace(regex, '')

                // Split name on whitespace, slashes, and ampersands and then capitalize each word.
                let words = name.split(/\W|\.\s/g);
                let capitalizedWords = words.map(word => {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                });
                // Join the capitalized words with a dash and return the result.
                let result = capitalizedWords.join('');

                result = 'nav' + result;

                return result
            }
        }
    }
}


</script>

<style scoped>
.accordion-item {
    background-color: #EEEFF0 !important;
    width: 100%;
}

.active {
    background-color: #e6e6e6 !important;
}

.accordion-button {
    background-color: #EEEFF0 !important;
    color: var(--bs-body-color) !important;
}

.accordion-button:not(.collapsed) {
    font-weight: 600;
    background-color: #e6e6e6 !important;
    color: var(--bs-body-color) !important;

}
</style>